import axios from "axios";
import configuration from "./configuration";

export async function capturePayment(token: string) {
  await axios.post(`${configuration.apiUrl}/payments/capture`, { token });
}
